//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapMutations, mapState} from 'vuex';
import {date as qDate} from 'quasar';
import {scroll} from 'quasar';

export default {
    name: 'PersonalData',
    data() {
        return {
            emailRule: [
                value => !!value || 'Pflichtfeld',
                value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || 'Ungültige E-Mail-Adresse';
                },
            ],
            dateRule: [
                value => !!value || 'Pflichtfeld',
                value => {
                    const validInputPattern = /^[0-3][0-9]\.[0-1][0-9]\.[1-2](9|0)[0-9]{2}$/;
                    return validInputPattern.test(value) || 'Bitte gülitiges Datum eingeben';
                },
                value => {
                    const newDate = new Date();
                    const calcDate = qDate.subtractFromDate(newDate, {year: 18});
                    return new Date(qDate.extractDate(value, 'DD.MM.YYYY')) < calcDate ||
                        'Sie müssen volljährig sein';
                },
            ],
            person: {},
            hasSecondTaxNumberLabel: 'Weiteres Land hinzufügen',
            sign: 'far fa-plus',
            optionsMaritalStatus: [
                'ledig',
                'verheiratet',
                'getrennt lebend',
                'zusammen lebend',
                'geschieden',
                'verwitwet'],
            checkBusinessOptions: [1, 2, 3, 4, 5, 17, 24],
            stopProcess: false,
            legalAge: false,
            employmentSituationOptions: [
                {label: 'Freiberufler', value: 1},
                {label: 'Kapitalvermögen', value: 16},
                {label: 'Gewerbetreibender', value: 2},
                {label: 'selbst. Handwerker', value: 3},
                {label: 'selbstständig i.R.', value: 4},
                {label: 'Handwerker i.R.', value: 5},
                {label: 'sonst. Selbständige', value: 17},
                {label: 'Angest. Privatw.', value: 6},
                {label: 'Angest. öffentl.', value: 7},
                {label: 'Beamter', value: 8},
                {label: 'Arbeiter Privatw.', value: 9},
                {label: 'Arbeiter öffentl.', value: 10},
                {label: 'Rentner/Pensionär', value: 11},
                {label: 'Hausfrau/Hausmann', value: 12},
                {label: 'Student', value: 13},
                {label: 'AZUBI,Praktikant', value: 15},
                {label: 'Asylbewerber', value: 18},
                {label: 'Sozialhilfeempfän.', value: 19},
                {label: 'arbeitslos', value: 20},
                {label: 'Schüler', value: 21},
                {label: 'Wehrdienstleist.', value: 22},
                {label: 'Zivildienstleist..', value: 23},
            ],
            zinspilot: false,
        };
    },
    computed: {
        ...mapState(['currency', 'accountDetails', 'persons', 'personStep', 'step']),
    },
    methods: {
        ...mapMutations([
            'setPerson', 'setPersons',
        ]),
        toggleSecondTaxNumberButton() {
            this.person.hasSecondTaxNumber = !this.person.hasSecondTaxNumber;
            if (this.person.hasSecondTaxNumber) {
                this.hasSecondTaxNumberLabel = 'Nicht benötigtes Land löschen';
                this.sign = 'far fa-minus';
            } else {
                this.hasSecondTaxNumberLabel = 'Weiteres Land hinzufügen';
                this.sign = 'far fa-plus';
            }
        },
        validateUSARadioButtons() {
            if (this.person.usaCitizen === 'ja' ||
                this.person.greenCard === 'ja' ||
                this.person.substantialPresence === 'ja' ||
                this.person.usaBorn === 'ja' ||
                this.person.usaAddress === 'ja' ||
                this.person.usaMobile === 'ja' ||
                this.person.usaAccountActivities === 'ja' ||
                this.person.usaSignatoryPower === 'ja') {
                this.stopProcess = true;
            } else {
                this.stopProcess = false;
            }
        },
        onSubmit() {
            this.validateUSARadioButtons();
            this.persons[this.personStep-1] = this.person;
            this.$store.dispatch('setPerson', this.person);
            this.$store.dispatch('setPersons', this.persons);
            if (this.accountDetails.accountType === 'singleAccount' && !this.stopProcess || this.persons.length ===
                2 && !this.stopProcess && this.personStep === 2) {
                this.$store.dispatch('setStep', this.step + 1);
            } else {
                this.$store.dispatch('setPersonStep', 2);
                if(this.persons.length > 1) {
                    if (Object.keys(this.persons[1]).length) {
                        this.person = this.persons[1];
                    } else {
                        this.person = this.initPerson();
                        this.$refs.personalData.reset();
                        if (this.$route.query.zp == 'true') {
                            this.zinspilot = true;
                            this.initZinspilot();
                        }
                    }
                } else {
                    this.person = this.initPerson();
                    this.$refs.personalData.reset();
                    if (this.$route.query.zp == 'true') {
                        this.zinspilot = true;
                        this.initZinspilot();
                    }
                }
                const {setScrollPosition} = scroll;
                setScrollPosition(window, 0, 500);
            }
        },
        initPerson() {
            return {
                salutation: null,
                title: '',
                firstName: '',
                name: '',
                street: '',
                postalCode: '',
                city: '',
                usaCitizen: null,
                greenCard: null,
                substantialPresence: null,
                usaBorn: null,
                usaAddress: null,
                usaMobile: null,
                usaAccountActivities: null,
                usaSignatoryPower: null,
                taxNumber: '',
                hasSecondTaxNumber: false,
                secondTaxNumber: '',
                country: '',
                maritalStatus: '',
                dateOfBirth: '',
                birthName: '',
                placeOfBirth: '',
                nationality: '',
                employmentSituation: '',
                legalAge: false,
                business: '',
                telefon: '',
                email: '',
                repeatEmail: '',
            };
        },
        initZinspilot() {
            this.zinspilot = true;
            this.person.usaCitizen = 'nein';
            this.person.greenCard = 'nein';
            this.person.substantialPresence = 'nein';
            this.person.usaBorn = 'nein';
            this.person.usaAddress = 'nein';
            this.person.usaMobile = 'nein';
            this.person.usaAccountActivities = 'nein';
            this.person.usaSignatoryPower = 'nein';
        },
        back() {
            switch (this.personStep) {
                case 1:
                    this.$store.dispatch('setStep', this.step - 1);
                    break;
                case 2:
                    this.person = this.persons[0];
                    this.$store.dispatch('setPersonStep', 1);
                    break;
            }
        },
    },
    created() {
        if(this.persons.length) {
            switch (this.personStep) {
                case 1:
                    this.person = this.persons[0];
                    break;
                case 2:
                    this.person = this.persons[1];
                    break;
            }
        } else {
            this.person = this.initPerson();
            if (this.$route.query.zp == 'true') {
                this.zinspilot = true;
                this.initZinspilot();
            }
        }
    },
};
